export interface RankingContent {
	title: string;
	drinksTitle: string;
	foodTitle: string;
}

export const rankingContent: RankingContent = {
	title: "PRODUTOS MAIS VENDIDOS DO ANO",
	drinksTitle: "🍺 Top 5 Bebidas Campeãs",
	foodTitle: "🍔 Top 5 Comidas Campeãs",
};
